import { IAdminSlice, TAdminPage } from "@/redux/slices/admin/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postAdminPage } from "@/lib/api-server/admin/page/postAdminPage";

export const postPage = createAsyncThunk(
  "admin/postPage",
  async (
    {
      page,
      storeUuid,
    }: {
      page: Partial<TAdminPage>;
      storeUuid: string;
    },
    { rejectWithValue }
  ) =>
    await postAdminPage(page, storeUuid).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

const rejected = (
  state: IAdminSlice,
  { meta }: { meta: { arg: TAdminPage } }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

const fulfilled = (
  state: IAdminSlice,
  { payload, meta }: { payload: TAdminPage; meta: { arg: TAdminPage } }
) => {
  state.pages.push(payload);
  state.current_page = payload.uuid;

  state.pages = state.pages.map((page: any) => {
    if (page.uuid === meta.arg.uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

export default {
  action: postPage,
  pending,
  rejected,
  fulfilled,
};
